import React from 'react';
import { IDataBox } from '../DataBox.types';
import { Item } from '../DataBox.styles';

export default function DataBoxItem({ children, testId = 'data-box-item' }: IDataBox) {
  return <Item data-testid={testId}>{children}</Item>;
}
